import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-20 pb-16 px-4 overflow-hidden" data-id="element-72">
      {/* Subtle radial glow background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-blue-900/20 rounded-full blur-[120px] -z-10 pointer-events-none" data-id="element-73"></div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-75">
          <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6 leading-tight tracking-tight" data-id="element-76">
            EL INTERRUPTOR DE NITRÓGENO
          </h1>
          <h2 className="text-xl md:text-2xl font-semibold text-blue-400 mb-4" data-id="element-77">
            El método de 7 minutos para recuperar la firmeza total esta misma
            noche
          </h2>
          <p className="text-sm md:text-base text-slate-400 mb-8 font-medium tracking-wide uppercase" data-id="element-78">
            (Sin pastillas, sin efectos secundarios y sin esperas)
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="max-w-3xl mx-auto mb-10" data-id="element-79">
          <p className="text-lg text-slate-300 leading-relaxed mb-6" data-id="element-80">
            Si alguna vez has sentido ese sudor frío al notar que tu cuerpo no
            responde en el momento crítico, sabes que no es solo frustración. Es
            una pérdida de confianza que se filtra en cada área de tu vida.
          </p>
          <p className="text-lg text-slate-300 leading-relaxed font-medium" data-id="element-81">
            El problema no es tu edad, ni tu deseo, ni tu "hombría". El problema
            es que tus arterias han olvidado cómo manejar la presión.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mb-12 relative mx-auto max-w-2xl" data-id="element-82">
          <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-transparent to-transparent z-10 pointer-events-none" data-id="element-83"></div>
          <img src="https://cdn.magicpatterns.com/uploads/8GjQLx96Yv1ZmBqYHfPkFb/Antes.png" alt="Comparación Antes y Después" className="w-full h-auto rounded-2xl shadow-2xl border border-slate-800" data-id="element-84" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="flex flex-col items-center gap-4" data-id="element-85">
          <a href="#comprar" className="flex justify-center items-center w-full max-w-md bg-blue-600 hover:bg-blue-500 text-white font-bold text-lg py-4 px-8 rounded-full transition-all duration-300 shadow-[0_0_20px_rgba(37,99,235,0.5)] hover:shadow-[0_0_35px_rgba(37,99,235,0.7)] hover:scale-105 active:scale-95" data-id="element-86">
            Descargar Protocolo Ahora
          </a>

          <div className="flex items-center gap-2 text-slate-400 text-sm font-medium bg-slate-900/50 py-1.5 px-4 rounded-full border border-slate-800" data-id="element-87">
            <ShieldCheck className="w-4 h-4 text-amber-500" data-id="element-88" />
            <span data-id="element-89">$6.99 USD · Por tiempo limitado</span>
          </div>
        </motion.div>
      </div>
    </section>;
}